var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-justify"},_vm._l((_vm.messagePool),function(message,messageNr){return _c('div',{key:messageNr},[_c('span',[_vm._v(_vm._s(messageNr + 1)+": ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("messageFilter")(message)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }